import FullTextSection from '@/components/elements/FullTextSection';
import React from 'react';
import { useTranslation } from 'next-i18next';
import TeamMemberSection from '@/components/modules/TeamMemberSection';
import DownloadCTA from '@/components/modules/DownloadCTA';
import Spacer from '@/components/elements/Spacer';
import ResourcesCarousel from '@/components/modules/ResourcesCarousel';
import { LogoJsonLd, NextSeo } from 'next-seo';

const AboutUsLayout = () => {
  const { t } = useTranslation(`about`);
  return (
    <>
      <NextSeo
        title={t(`page_title`)}
        description={t(`page_title`)}
        openGraph={{
          title: t(`page_title`),
          description: t(`page_description`),
        }}
      />
      <LogoJsonLd logo="/logo.png" url="https://voltranapp.com" />
      <Spacer height={100} />
      <FullTextSection
        id="our-aim"
        title={t(`section_one.header`)}
        lead={t(`section_one.lead`)}
        mainParagraph={t(`section_one.main_paragraph`)}
        secondParagraph={t(`section_one.second_paragraph`)}
        thirdParagraph={t(`section_one.third_paragraph`)}
      />
      <FullTextSection
        id="team"
        title={t(`section_two.header`)}
        lead={t(`section_two.lead`)}
        mainParagraph={t(`section_two.main_paragraph`)}
        secondParagraph={t(`section_two.second_paragraph`)}
        thirdParagraph={t(`section_two.third_paragraph`)}
        lastParagraph={t(`section_two.last_line`)}
        isReverse
      />
      <TeamMemberSection
        members={[
          {
            image: `/images/about-us/berk.jpg`,
            name: `Berk Kıncıoğlu`,
            role: t(`roles.product_manager`),
          },
          {
            image: `/images/about-us/buket.jpg`,
            name: `Buket Öğütler`,
            role: t(`roles.user_interface_designer`),
          },
          {
            image: `/images/about-us/anil.jpg`,
            name: `Anıl Kıncıoğlu`,
            role: t(`roles.cash_flow`),
          },
          {
            image: `/images/about-us/hamedi.jpg`,
            name: `Hamed Hamedi`,
            role: t(`roles.technology`),
          },
        ]}
      />
      <Spacer height={100} />
      <DownloadCTA />
      <Spacer height={100} />
      <ResourcesCarousel />
      <Spacer height={100} />
    </>
  );
};

export default AboutUsLayout;
